import "./Profile.css";
import React, { useState } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import tof3 from '../../../Assets/imge/istockphoto-1270067126-612x612.jpg';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { MdOutlineAddAPhoto } from "react-icons/md";
import { db, auth } from "../../../Firebase";

function Profile() {
  const user_id = auth.currentUser.uid || null;
  console.log(user_id);
  // const user_id = sessionStorage.getItem("user_id");
  const [currentUserData, setCurrentUserData] = useState();



  return (

    <div className="profile" id="profile">
      <h2>Modifier vos informations</h2>
      <div className="" style={{ background: '#FFF' }}>

        <Container fluid>
          <Row className="py-5 mx-0">
            <Col lg={4} className="text-center blocProfil">
              <div className="updatephoto">
                <img src={tof3} alt='tof3' className="imgprofil" />
                <div className="iconBox">
                  <MdOutlineAddAPhoto className="fs-4"/>
                </div>
              </div>

              <div className="vvd">

                <span className="textsapn">Babacar sall</span> <br />
                <span className="textsapn"  >Admin</span><br />

              </div>
            </Col>
            <Col lg={8}>

              <Form className="me-auto">

                <Form.Group className="mb-3" controlId="formBasicPrenom">
                  <Form.Label>Prénom</Form.Label>
                  <Form.Control type="text" placeholder="Enter Prenom" />

                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicNom">
                  <Form.Label>Nom</Form.Label>
                  <Form.Control type="email" placeholder="Enter email" />

                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" placeholder="Enter email" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicResidence">
                  <Form.Label>Résidence</Form.Label>
                  <Form.Control type="email" placeholder="Status" />
                </Form.Group>
                <Button variant="primary" className="btnnt btn btn-md" type="submit">
                  Mettre a jour
                </Button>
              </Form>
            </Col>
           
          </Row>

        </Container>

      </div>
    </div>
  );
};

export default Profile;
